"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _bwaRedirectFallbackPopupRenderHandler = _interopRequireDefault(require("./bwa-redirect-fallback-popup-render-handler"));
var BwaRedirectFallbackPopup = exports["default"] = /*#__PURE__*/function () {
  function BwaRedirectFallbackPopup(checkoutUrl) {
    var _this = this;
    var checkoutId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    (0, _classCallCheck2["default"])(this, BwaRedirectFallbackPopup);
    this.checkoutUrl = checkoutUrl;
    this.checkoutId = checkoutId;
    if (document.readyState === "complete" || document.readyState === "interactive") {
      this.initRenderHandler();
    } else {
      document.addEventListener("DOMContentLoaded", function () {
        return _this.initRenderHandler();
      });
    }
  }
  return (0, _createClass2["default"])(BwaRedirectFallbackPopup, [{
    key: "initRenderHandler",
    value: function () {
      var _initRenderHandler = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var renderHandler;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              renderHandler = new _bwaRedirectFallbackPopupRenderHandler["default"](this.checkoutUrl, this.checkoutId);
              _context.next = 3;
              return renderHandler.executeHandler();
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function initRenderHandler() {
        return _initRenderHandler.apply(this, arguments);
      }
      return initRenderHandler;
    }()
  }], [{
    key: "dismiss",
    value: function dismiss() {
      var _document$querySelect, _document$querySelect2;
      (_document$querySelect = document.querySelector('.bwa-redirect-fallback-modal-overlay')) === null || _document$querySelect === void 0 || _document$querySelect.remove();
      (_document$querySelect2 = document.querySelector('.bwa-redirect-fallback-modal')) === null || _document$querySelect2 === void 0 || _document$querySelect2.remove();
      document.body.classList.remove('bwa-no-scroll');
    }
  }]);
}();
//# sourceMappingURL=bwa-redirect-fallback-popup.js.map
